import React, {
  useEffect,
  useState
} from "react";

import {
  useParams
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaFilePdf,
  FaDownload,
  FaEye,
  FaUserGraduate
} from "react-icons/fa";

const StudentTcDetails = () => {
  const [open, setOpen] =
    useState(false);

  const [data, setData] =
    useState([]);

  const { id } =
    useParams();

  useEffect(() => {
    fetch(
      `https://stjosephweb.ilakshyaerp.in/api/student-tc/class/${id}`
    )
      .then((res) =>
        res.json()
      )
      .then((res) =>
        setData(
          Array.isArray(res)
            ? res
            : []
        )
      );
  }, [id]);

  const downloadFile =
    async (
      file,
      name
    ) => {
      const url = `https://stjosephweb.ilakshyaerp.in/uploads/student-tc/${file}`;

      const res =
        await fetch(
          url
        );

      const blob =
        await res.blob();

      const link =
        document.createElement(
          "a"
        );

      link.href =
        window.URL.createObjectURL(
          blob
        );

      link.download =
        name;

      link.click();
    };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#072F5F] py-16">

        <div className="max-w-7xl mx-auto px-5 text-center">

          <h1 className="text-4xl md:text-5xl font-extrabold text-white">

            STUDENT TC RECORDS

          </h1>

          <p className="text-gray-200 text-lg mt-5">

            View & Download Student
            Transfer Certificates

          </p>

          <div className="w-28 h-1 bg-[#D4A017] mx-auto rounded-full mt-5"></div>

        </div>

      </section>

      {/* RECORDS */}
      <section className="bg-[#f7f9fc] py-16 min-h-screen">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* HEADING */}
          <div className="text-center mb-16">

            <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

              Student Records

            </span>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

              Transfer Certificates

            </h2>

          </div>

          {/* GRID */}
          {data.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

              {data.map(
                (item) => {
                  const url = `https://stjosephweb.ilakshyaerp.in/uploads/student-tc/${item.file}`;

                  return (
                    <div
                      key={
                        item.id
                      }
                      className="group bg-white rounded-[30px] shadow-lg hover:shadow-2xl border border-gray-100 transition-all duration-500 hover:-translate-y-2 overflow-hidden"
                    >

                      {/* TOP BAR */}
                      <div className="h-2 bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#D4A017]"></div>

                      {/* BODY */}
                      <div className="p-8 text-center">

                        {/* PDF ICON */}
                        <a
                          href={url}
                          target="_blank"
                          rel="noreferrer"
                          className="w-24 h-24 rounded-3xl bg-red-50 text-red-600 flex items-center justify-center text-5xl mx-auto mb-8 shadow-md group-hover:scale-110 transition-all duration-300"
                          title="Preview File"
                        >

                          <FaFilePdf />

                        </a>

                        {/* NAME */}
                        <h3 className="text-2xl font-extrabold text-[#072F5F] leading-snug">

                          {
                            item.student_name
                          }

                        </h3>

                        {/* LINE */}
                        <div className="w-16 h-1 bg-[#D4A017] rounded-full mx-auto mt-5 mb-5"></div>

                        {/* ROLL */}
                        <p className="text-gray-600 text-lg">

                          Roll No :
                          <span className="font-bold text-[#072F5F] ml-2">

                            {
                              item.roll_no
                            }

                          </span>

                        </p>

                        {/* BUTTONS */}
                        <div className="flex flex-wrap justify-center gap-4 mt-8">

                          {/* PREVIEW */}
                          <a
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-3 bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-5 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-lg hover:-translate-y-1"
                          >

                            <FaEye />

                            Preview

                          </a>

                          {/* DOWNLOAD */}
                          <button
                            onClick={() =>
                              downloadFile(
                                item.file,
                                item.student_name
                              )
                            }
                            className="flex items-center gap-3 bg-[#D4A017] hover:bg-[#c59212] text-white px-5 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-lg hover:-translate-y-1"
                          >

                            <FaDownload />

                            Download

                          </button>

                        </div>

                      </div>

                    </div>
                  );
                }
              )}

            </div>
          ) : (
            <div className="bg-white rounded-[35px] shadow-xl border border-gray-100 p-16 text-center">

              <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mx-auto mb-6">

                <FaUserGraduate />

              </div>

              <h3 className="text-3xl font-extrabold text-[#072F5F]">

                No Records Available

              </h3>

              <p className="text-gray-500 mt-4 text-lg">

                Student TC records will
                appear here soon.

              </p>

            </div>
          )}

        </div>

      </section>

      <Footer />
    </>
  );
};

export default StudentTcDetails;